import cultural1 from "../../assets/images/cultural1.jpg";
import cultural2 from "../../assets/images/cultural2.jpg";
import cultural3 from "../../assets/images/cultural3.jpg";
import cultural4 from "../../assets/images/cultural4.jpg";
import cultural5 from "../../assets/images/cultural5.jpg";
import cultural6 from "../../assets/images/cultural6.jpg";
import cultural7 from "../../assets/images/cultural7.jpg";
import cultural9 from "../../assets/images/cultural9.jpg";
import cultural10 from "../../assets/images/cultural10.jpg";
import cultural11 from "../../assets/images/cultural11.jpg";
import cultural13 from "../../assets/images/cultural13.jpg";
import cultural15 from "../../assets/images/cultural15.jpg";
import cultural16 from "../../assets/images/cultural16.jpg";
import cultural17 from "../../assets/images/cultural17.jpg";
import cultural18 from "../../assets/images/cultural18.jpg";
import cultural217 from "../../assets/images/cultural217.jpg";
import fruit1 from "../../assets/images/fruit1.jpg";
import fruit2 from "../../assets/images/fruit2.jpg";
import fruit3 from "../../assets/images/fruit3.jpg";
import fruit4 from "../../assets/images/fruit4.jpg";
import fruit5 from "../../assets/images/fruit5.jpg";
import fruit6 from "../../assets/images/fruit6.jpg";
import fruit7 from "../../assets/images/fruit7.jpg";
import fruit8 from "../../assets/images/fruit8.jpg";
import fruit9 from "../../assets/images/fruit9.jpg";
import fruit10 from "../../assets/images/fruit10.jpg";
import fruit11 from "../../assets/images/fruit11.jpg";
import radio from "../../assets/images/radio.jpg";
import redcross1 from "../../assets/images/redcross1.jpg";
import redcross2 from "../../assets/images/redcross2.jpg";
import school_director from "../../assets/images/school_director.jpg";
import triumphant_flyer from "../../assets/images/triumphant_flyer.jpg";
import triumphant_logo from "../../assets/images/triumphant_logo.jpg";
import triumphant_logoC from "../../assets/images/triumphant_logoC.png";
import lab from "../../assets/images/lab.jpeg";
import computer1 from "../../assets/images/computer1.jpg";
import cloud_up from "../../assets/images/cloud_up.png";

import cloud_down from "../../assets/images/cloud_down.png";
import secondary from "../../assets/images/secondary.jpg";
import primary from "../../assets/images/primary.jpg";
import creche from "../../assets/images/creche.jpg";
import new_flyer from "../../assets/images/new_t_flyer.jpg";

export default {
  new_flyer,
  secondary,
  primary,
  creche,
  cultural1,
  cultural2,
  cultural3,
  cultural4,
  cultural5,
  cultural6,
  cultural7,
  cultural9,
  cultural10,
  cultural11,
  cultural13,
  cultural15,
  cultural16,
  cultural17,
  cultural18,
  cultural217,
  fruit1,
  fruit2,
  fruit3,
  fruit4,
  fruit5,
  fruit6,
  fruit7,
  fruit8,
  fruit9,
  fruit10,
  fruit11,
  radio,
  redcross1,
  redcross2,
  school_director,
  triumphant_flyer,
  triumphant_logo,
  triumphant_logoC,
  lab,
  computer1,
  cloud_up,
  cloud_down,
};
